import React from 'react';
import { SignUp } from 'layer7-apihub';

import { AuthenticationLayout } from './AuthenticationLayout';

export const SignUpPage = () => {
    return (
        <AuthenticationLayout>
            <SignUp
                toolbarProps={{
                    button: {
                        variant: 'contained',
                    },
                }}
            />
        </AuthenticationLayout>
    );
};
